import React from 'react';
import { useGetOptions, SelectInputProps } from "../../../../../hooks/report/useGetOptions";
import { BoundSelect } from "../BoundSelect";
import { SubscriptionType } from "../../../../constants/securspace-constants";

type BoundSubscriptionTypeSelectProps<T> = {
  label?: string;
  name: string;
  value?: string | number | null;
  onChange: (newQuery: T) => void;
}

const BoundSubscriptionTypeSelect = <T,>({
  label = "Subscription Type",
  name,
  value = '',
  onChange
}: BoundSubscriptionTypeSelectProps<T>) => {

  return <BoundSelect<T>
    options={useGetOptions({optionFormat: 'SELECT', options: SubscriptionType}) as unknown as SelectInputProps[]}
    label={label}
    name={name}
    value={value}
    onChange={onChange}
  />
}

export { BoundSubscriptionTypeSelect };